import React from 'react';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  initials?: string;
  size?: 'sm' | 'md' | 'lg';
  alt?: string;
}

export function Avatar({
  src,
  initials,
  size = 'md',
  alt = 'Avatar',
  className = '',
  ...props
}: AvatarProps) {
  const sizes = {
    sm: 'aspectly:w-8 aspectly:h-8 aspectly:text-xs',
    md: 'aspectly:w-10 aspectly:h-10 aspectly:text-sm',
    lg: 'aspectly:w-12 aspectly:h-12 aspectly:text-base',
  };

  return (
    <div
      className={`${sizes[size]} aspectly:rounded-full aspectly:bg-primary-container aspectly:overflow-hidden aspectly:ring-2 aspectly:ring-primary-container aspectly:flex aspectly:items-center aspectly:justify-center ${className}`}
      {...props}
    >
      {src ? (
        <img alt={alt} className="aspectly:w-full aspectly:h-full aspectly:object-cover" src={src} />
      ) : (
        <span className="aspectly:text-primary aspectly:font-black aspectly:uppercase">{initials || '?'}</span>
      )}
    </div>
  );
}
